import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface TuyenDungState {
  yeuCauTuyenDungList?: any
  dangTuyenList?: any
  ungVienList?: any
  lichPhongVanList?: any
  thuMoiLamViecList?: any
  huongDanNhanViecList?: any
  thongKeList?: any
  reloadTuyenDungList?: string | null
}

const initialState: TuyenDungState = {
  yeuCauTuyenDungList: initialDataList,
  dangTuyenList: initialDataList,
  ungVienList: initialDataList,
  lichPhongVanList: initialDataList,
  thuMoiLamViecList: initialDataList,
  huongDanNhanViecList: initialDataList,
  thongKeList: initialDataList,
  reloadTuyenDungList: null,
}

export const tuyenDungDucks = createSlice({
  name: 'tuyenDung',
  initialState,
  reducers: {
    // Yêu cầu tuyển dụng
    layDanhSachYeuCauTuyenDung: (state: RootState, action: PayloadAction<any>) => {
      state.yeuCauTuyenDungList = { loading: true, queryStr: action.payload }
    },
    layDanhSachYeuCauTuyenDungThanhCong: (state, action: PayloadAction<any>) => {
      state.yeuCauTuyenDungList = { loading: false, ...action.payload }
    },
    layDanhSachYeuCauTuyenDungThatBai: (state, action: PayloadAction<any>) => {
      state.yeuCauTuyenDungList = { loading: false, ...action.payload }
    },

    // Đăng tuyển
    layDanhSachDangTuyen: (state: RootState, action: PayloadAction<any>) => {
      state.dangTuyenList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDangTuyenThanhCong: (state, action: PayloadAction<any>) => {
      state.dangTuyenList = { loading: false, ...action.payload }
    },
    layDanhSachDangTuyenThatBai: (state, action: PayloadAction<any>) => {
      state.dangTuyenList = { loading: false, ...action.payload }
    },

    // Ứng viên
    layDanhSachUngVien: (state: RootState, action: PayloadAction<any>) => {
      state.ungVienList = { loading: true, queryStr: action.payload }
    },
    layDanhSachUngVienThanhCong: (state, action: PayloadAction<any>) => {
      state.ungVienList = { loading: false, ...action.payload }
    },
    layDanhSachUngVienThatBai: (state, action: PayloadAction<any>) => {
      state.ungVienList = { loading: false, ...action.payload }
    },

    // Lịch phỏng vấn
    layDanhSachLichPhongVan: (state: RootState, action: PayloadAction<any>) => {
      state.lichPhongVanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachLichPhongVanThanhCong: (state, action: PayloadAction<any>) => {
      state.lichPhongVanList = { loading: false, ...action.payload }
    },
    layDanhSachLichPhongVanThatBai: (state, action: PayloadAction<any>) => {
      state.lichPhongVanList = { loading: false, ...action.payload }
    },

    // Thư mời làm việc
    layDanhSachThuMoiLamViec: (state: RootState, action: PayloadAction<any>) => {
      state.thuMoiLamViecList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThuMoiLamViecThanhCong: (state, action: PayloadAction<any>) => {
      state.thuMoiLamViecList = { loading: false, ...action.payload }
    },
    layDanhSachThuMoiLamViecThatBai: (state, action: PayloadAction<any>) => {
      state.thuMoiLamViecList = { loading: false, ...action.payload }
    },

    // Hướng dẫn nhân viên
    layDanhSachHuongDanNhanViec: (state: RootState, action: PayloadAction<any>) => {
      state.huongDanNhanViecList = { loading: true, queryStr: action.payload }
    },
    layDanhSachHuongDanNhanViecThanhCong: (state, action: PayloadAction<any>) => {
      state.huongDanNhanViecList = { loading: false, ...action.payload }
    },
    layDanhSachHuongDanNhanViecThatBai: (state, action: PayloadAction<any>) => {
      state.huongDanNhanViecList = { loading: false, ...action.payload }
    },

    // Thống kê
    layDanhSachThongKe: (state: RootState, action: PayloadAction<any>) => {
      state.thongKeList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThongKeThanhCong: (state, action: PayloadAction<any>) => {
      state.thongKeList = { loading: false, ...action.payload }
    },
    layDanhSachThongKeThatBai: (state, action: PayloadAction<any>) => {
      state.thongKeList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachTuyenDung: (state: RootState) => {
      state.reloadTuyenDungList = String(Date.now())
    },
  },
})

export const {
  layDanhSachYeuCauTuyenDung,
  layDanhSachYeuCauTuyenDungThanhCong,
  layDanhSachYeuCauTuyenDungThatBai,
  layDanhSachDangTuyen,
  layDanhSachDangTuyenThanhCong,
  layDanhSachDangTuyenThatBai,
  layDanhSachUngVien,
  layDanhSachUngVienThanhCong,
  layDanhSachUngVienThatBai,
  layDanhSachLichPhongVan,
  layDanhSachLichPhongVanThanhCong,
  layDanhSachLichPhongVanThatBai,
  layDanhSachThuMoiLamViec,
  layDanhSachThuMoiLamViecThanhCong,
  layDanhSachThuMoiLamViecThatBai,
  layDanhSachHuongDanNhanViec,
  layDanhSachHuongDanNhanViecThanhCong,
  layDanhSachHuongDanNhanViecThatBai,
  layDanhSachThongKe,
  layDanhSachThongKeThanhCong,
  layDanhSachThongKeThatBai,
  datTaiLaiDanhSachTuyenDung,
} = tuyenDungDucks.actions

export default tuyenDungDucks.reducer
